import BackButton from "../../components/BackButton/BackButton";
import { useLocation, useNavigate, useParams } from "react-router";
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import AiVoiceanimation from "../../components/AiVoiceanimation/AiVoiceanimation";
import { useDispatch, useSelector } from "react-redux";
import OverviewLesson from "../../pages/home/components/dashboard/teacher/lessons/OverviewLesson";
import { useEffect, useRef, useState } from "react";
import "./LessonAndAssignmentTab.css";
import MultipleAssignment from "../MultipleAssignments/MultipleAssignment";
import { getAssignmentsByLesson, resetAssignmentsList } from "../../state/actions/getAssignmentsByLessonAction";
import { getLessonAudio, resetLessonAudio } from "../../../src/state/actions/getLessonAudioSocketAction";
import { CircularProgress } from "@mui/material";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData, setAgentData, setInitialProjectId } from "../../state/reducers/chatDrawerReducers";

function LessonAndAssignmentTab() {


  const location = useLocation();
  const navigate = useNavigate();
  const { token } = useAuth();
  const { lesson_id } = useParams();
  const dispatch = useDispatch();
  //const [activeTab, setActiveTab] = useState(location?.state?.activeTab || "lessons"); // Default active tab is 'lessons'
  const [activeTab, setActiveTab] = useState(() => { return localStorage.getItem("ActiveTab") || "lessons" }); //bb
  const [lessonParent, setlessonParent] = useState(location?.state?.lesson || {}); // Default active tab is 'lessons' 
  const [courseDetails, setcourseDetails] = useState(location?.state?.course || {});
  const [rubricDetails, setrubricDetails] = useState({});
  const [assignmentCount, setassignmentCount] = useState(0)
  const [assignmentCountLoading, setAssignmentCountLoading] = useState(true);
  const [showDownloadFile, setshowDownloadFile] = useState(false);
  const modalContentRef = useRef();
  const [canDownload, setCanDownload] = useState(false);
  const [lessonFiles, setLessonFiles] = useState([]);
  const courseId = location?.state?.course?.course_id
  const [currentPage, setCurrentPage] = useState(1);
  const [lessonPart, setLessonPart] = useState(location?.state?.lesson || {});
  const [isPlaying, setIsPlaying] = useState(false);
  const courseType = location?.state?.course?.course_type
  const getassignmentsbyLesson = useSelector((state) => state.getassignmentsbyLesson);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const [hideTimer, setHideTimer] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  useEffect(() => {
    const html = document.documentElement;
    const previousValue = html.style.scrollbarGutter;
    html.style.scrollbarGutter = "stable";
    return () => {
      html.style.scrollbarGutter = previousValue;
    };
  }, []);

  useEffect(() => {
    if (getassignmentsbyLesson.assignments && getassignmentsbyLesson.assignments.length > 0) {
      // Get hide_timer from the first assignment (or whichever assignment is currently active)
      const firstAssignment = getassignmentsbyLesson.assignments[0];
      setHideTimer(firstAssignment?.hide_timer || false);
    }
  }, [getassignmentsbyLesson.assignments]);

  useEffect(() => {
    dispatch(getAssignmentsByLesson(lesson_id, currentPage, token, courseType));
  }, [currentPage])

  const removeImageTags = (htmlString) => {
    return htmlString.replace(/<img[^>]*>/gi, '');
  };

  useEffect(() => {
    if (isPlaying && activeTab === "lessons" && lessonPart) {

      dispatch(getLessonAudio({
        text: removeImageTags(lessonPart.description),
        mode: "lesson",
        lessonId: parseInt(lesson_id),
        token,
      }));
    } else {
      // Closing the player aborts whatever generation is still in flight.
      dispatch(resetLessonAudio());
    }
  }, [isPlaying])


  useEffect(() => {
    return () => {
      dispatch(resetLessonAudio());
    }
  }, [])



  // useEffect(() => {

  //   setassignmentCount(getassignmentsbyLesson.count)
  //   const assignArr = getassignmentsbyLesson.assignments?.filter((assign) => assign.ai_feedback_json === null || assign.assignment_json
  //     === null)
  //   if (assignArr.length > 0) {
  //     setTimeout(() => {
  //       dispatch(getAssignmentsByLesson(lesson_id, currentPage, token));
  //     }, 30000);
  //   }
  // }, [getassignmentsbyLesson]);


  const apiTimeout = useRef(null);

  useEffect(() => {
    if (getassignmentsbyLesson.count !== undefined) {
      setassignmentCount(getassignmentsbyLesson.count);
      setAssignmentCountLoading(false);
    }

    const assignArr = getassignmentsbyLesson.assignments?.filter((assign) => assign.ai_feedback_json === null || assign.assignment_json === null);

    if (assignArr.length > 0) {
      if (apiTimeout.current) {
        clearTimeout(apiTimeout.current); // Clear any existing timeout
      }

      apiTimeout.current = setTimeout(() => {
        dispatch(getAssignmentsByLesson(lesson_id, currentPage, token, courseType));
      }, 30000);
    }

    return () => {
      if (apiTimeout.current) {
        clearTimeout(apiTimeout.current); // Clean up the timeout on unmount
      }
    };
  }, [getassignmentsbyLesson]);




  useEffect(() => {
    return () => {
      dispatch(resetAssignmentsList());
    };
  }, []);




  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };
  const openModal = () => {
    setshowDownloadFile(true);
  };


  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    if (tabName === "Assignments") {
      localStorage.setItem("ActiveTab", tabName)
    }
    else {
      localStorage.setItem("ActiveTab", tabName)

    }
  };


  useEffect(() => {
    return () => {
      localStorage.removeItem("ActiveTab")
    }
  }, [location])

  const getLessonById = async (course_id, lesson_id) => {
    await api
      .get(`lessons/get-lesson/${lesson_id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setCanDownload(response?.data?.data?.is_file_download);

        } else {
        }
      })
      .catch((error) => { });
  };

  useEffect(() => {
    if (courseId) {
      getLessonById(courseId, lesson_id);
    }
    return () => { };
  }, [courseId, lesson_id]);




  const downloadAsPdf = async () => {

    if (!canDownload) {
      toast.error("Downloading is disabled for this lesson.");
      return;
    }

    try {
      setDownloadLoading(true);
      const response = await api.post(`auth/convert-html-to-pdf/`, { html_text: lessonParent.description }, {
        responseType: 'blob',  // Important for handling binary data
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${lessonParent?.name}.pdf`); // or any other extension
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        toast.success("Download successful!");
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error("Download failed.");
    }
    finally {
      setDownloadLoading(false);
    }
  };

  const initiateDownload = (file) => {
    fetch(file.file_url)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.download = file.original_name;
        document.body.appendChild(link);
        link.dispatchEvent(new MouseEvent('click'));
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      })
      .catch(error => console.error('Download failed:', error));
  };


  const downloadAllFiles = () => {
    if (!canDownload) {
      toast.error("Downloading is disabled for this lesson.");
      return;
    }

    if (lessonFiles.length === 0) {
      toast.error("No files to download.");
      return;
    }

    toast.info(`Starting download of ${lessonFiles.length} files...`);

    lessonFiles.forEach((file, index) => {
      setTimeout(() => {
        initiateDownload(file);
      }, index * 100);  // Small delay between each download (100 ms)
    });
  };


  if (location.state === null) {
    navigate("/dashboard/home");
    return;
  }



  return (
    <>
      <div className="lesson-andassignment-tab-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              {
                <div className="Overview-Lesson-top-header mb-0" >
                  {/* <BackButton buttonName={lessonParent?.name} /> */}

                  <div class="Back_button"  onClick={() => {
                    if(location?.state?.goBack){
                      navigate(location.state.goBack, { state: 'after submission' })
                    } else {
                      navigate(`/course/${courseId}/`, { state: 'after submission' })
                    }
                  } }>
                    <i class="fa-solid fa-chevron-left"></i>
                    <span data-tooltip-id="lesson-button-name">{lessonParent?.name}</span>
                    <Tooltip
                      id="lesson-button-name"
                      className="p-2 ml-12"
                      place="auto"
                      content={`${lessonParent?.name}`}
                      type="light"
                     /*  effect="float" */
                    />
                  </div>

                  <div className="lesson-andassignment-tab-container">
                    <button
                      className={`tab-button ${activeTab === "lessons" ? "active" : ""
                        }`}
                      onClick={() => handleTabClick("lessons")}
                    >
                      Lesson
                    </button>
                    <button
                      className={`tab-button ${activeTab === "Assignments" ? "active" : ""
                        }`}
                      onClick={() => {
                        handleTabClick("Assignments");
                        setIsPlaying(false);
                      }}
                    >
                      {assignmentCountLoading ? (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <CircularProgress size={12} />
                          Loading...
                        </span>
                      ) : (
                        assignmentCount > 0 ? (assignmentCount == 1 ? `Assignment: ${assignmentCount}` : `Assignments: ${assignmentCount}`) : `Assignments: 0`
                      )}
                    </button>
                  </div>
                  <div className={`Overview-Lesson-ai-voice-animation-folder ${activeTab !== 'lessons' ? 'invisible pointer-events-none' : ''}`}>
                      <>
                        {
                          lessonFiles.length > 1 ? (
                            <div className="Overview-Lesson-downlode-btn">
                              <span onClick={downloadAllFiles}>
                                <i
                                  className="fa-regular fa-file"
                                  data-tooltip-id="download-data-workboardd222"
                                ></i>
                                <Tooltip
                                  id="download-data-workboardd222"
                                  place="top"
                                  content={lessonFiles[0].original_name}
                                  type="light"
                                  effect="float"
                                />
                              </span>
                            </div>
                          ) : (canDownload &&
                            lessonFiles.map((file, index) => (
                              (
                                <div
                                  className="Overview-Lesson-downlode-btn"
                                  onClick={downloadAllFiles}
                                  key={index}
                                >
                                  <span>
                                    <i
                                      className="fa-regular fa-file"
                                      data-tooltip-id={`download-data-workboardd${index}`}
                                    ></i>
                                    <Tooltip
                                      id={`download-data-workboardd${index}`}
                                      place="top"
                                      content={file.original_name}
                                      type="light"
                                      effect="float"
                                    />
                                  </span>
                                </div>
                              )
                            ))
                          )
                        }
                      </>
                      {lessonParent?.is_skip ? (<></>) : (canDownload && 
                      <>
                      {downloadLoading ? (<CircularProgress size={20} style={{ color: '#00C8B1' }} />) :
                      <div
                        className="Overview-Lesson-downlode-btn"
                        onClick={downloadAsPdf}
                      >
                        <span onClick={openModal}>
                          <i
                            className="fa-solid fa-download"
                            data-tooltip-id="download-data-workboard"
                          ></i>
                          <Tooltip
                            id="download-data-workboard"
                            place="top"
                            content="Download lesson"
                            type="light"
                            effect="float"
                          />
                        </span>
                      </div>}
                      </>
                      )
                      }

                      {
                        lessonParent?.is_skip ? (<></>) : (<div className="play-pause-btn-Overview-lesson-generator" onClick={togglePlay}>
                          <span>
                            <i className={isPlaying ? "fa-regular fa-circle-pause" : "fa-regular fa-circle-play"} data-tooltip-id="play-pause-tooltip"></i>
                            <Tooltip
                              id="play-pause-tooltip"
                              place="top"
                              content="Play lesson"
                              type="light"
                              effect="float"
                            />
                          </span>
                        </div>)
                      }
                  </div>
        {activeTab === "lessons" && isPlaying && <AiVoiceanimation togglePlay={togglePlay} />}

                </div>
              }
            </div>
          </div>
        </div>
        <div className="tab-content">
          {activeTab === "lessons" && (
            <>
              <OverviewLesson
                setlessonParent={setlessonParent}
                setCanDownloadParent={setCanDownload}
                setLessonFilesParent={setLessonFiles}
                setrubricDetails={setrubricDetails}
                setLessonPart={setLessonPart}
                setIsPlayingTwo={setIsPlaying}
                setParentActiveTab={setActiveTab}
              />
              <FloatingAIButton
                onClick={() => {
                  const agentData = [
                    {
                      key: courseDetails?.name || "Course",
                      value: String(courseDetails?.course_id || ""),
                    },
                  ];
                            
                  dispatch(setAgentData(agentData));
                    if (courseDetails?.course_id) {
                      dispatch(setInitialProjectId(String(courseDetails?.course_id)));
                    }
                  dispatch(setDrawerState(!chatDrawerState.isOpen));
                  dispatch(setIsWebAllowed(true));
                  dispatch(setQueryMetaData(null));
                }}
              />
            </>
          )}
          {activeTab === "Assignments" && (
            <>
              <MultipleAssignment lesson={lessonParent} course={courseDetails} rubrics={rubricDetails} setrubricDetails={setrubricDetails} currentPage={currentPage} setCurrentPage={setCurrentPage} hide_timer={hideTimer} />
              <FloatingAIButton
                onClick={() => {
                  const agentData = [
                    {
                      key: courseDetails?.name || "Course",
                      value: String(courseDetails?.course_id || ""),
                    },
                  ];
                            
                  dispatch(setAgentData(agentData));
                    if (courseDetails?.course_id) {
                      dispatch(setInitialProjectId(String(courseDetails?.course_id)));
                    }
                  dispatch(setDrawerState(!chatDrawerState.isOpen));
                  dispatch(setIsWebAllowed(true));
                  dispatch(setQueryMetaData(null));
                }}
              />
            </>
          )}
        </div>

        {/* {activeTab === "lessons" && isPlaying && <AiVoiceanimation togglePlay={togglePlay} />} */}
      </div>
    </>
  );
}

export default LessonAndAssignmentTab;